import { call, take, put } from 'redux-saga/effects';
import { get, deleteMethod } from '../../utils/api';
import settings from '../../utils/settings';

import {
  API_ACCESS_REQUEST,
  API_ACCESS_SUCCESS,
  REVOKE_API_ACCESS_REQUEST,
  REVOKE_API_ACCESS_SUCCESS,
  REQUEST_FAILURE
} from './constants';

export function* getAPIAccess() {
  while (true) {
    yield take(API_ACCESS_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/api-enabled-systems`)
      });
      if (response.success) {
        yield put({ type: API_ACCESS_SUCCESS, apiAccessData: response.result });
      } else {
        yield put({ type: REQUEST_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getAPIAccess:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* revokeAPIAccess() {
  while (true) {
    const request = yield take(REVOKE_API_ACCESS_REQUEST);
    try {
      let response;
      const { appId, successCbk } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/revoke-app-access?app_id=${appId}`)
      });
      if (response.success) {
        yield put({ type: REVOKE_API_ACCESS_SUCCESS });
        successCbk();
      } else {
        yield put({ type: REQUEST_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: revokeAPIAccess:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}
